var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9769 14V12.6667C10.9769 11.9594 10.6959 11.2811 10.1958 10.781C9.69574 10.281 9.01747 10 8.31022 10H4.31022C3.60298 10 2.9247 10.281 2.4246 10.781C1.92451 11.2811 1.64355 11.9594 1.64355 12.6667V14",
    stroke: "#53EAFD",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.31022 7.33333C7.78298 7.33333 8.97689 6.13943 8.97689 4.66667C8.97689 3.19391 7.78298 2 6.31022 2C4.83746 2 3.64355 3.19391 3.64355 4.66667C3.64355 6.13943 4.83746 7.33333 6.31022 7.33333Z",
    stroke: "#53EAFD",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9775 7.33333L12.3109 8.66667L14.9775 6",
    stroke: "#53EAFD",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonss);
export default __webpack_public_path__ + "static/media/personss.415319bc5b65f80b24e9574b7ff72b5e.svg";
export { ForwardRef as ReactComponent };